<template>
  <div class="footer-copyright">
    <div class="copyright-content">
      <p class="copyright-text">
        © {{ t('layout.footer.copyright.schoolName') }} 1992–{{ currentYear }}
      </p>
    </div>
  </div>
</template>

<script setup lang="ts">
const { t, locale } = useI18n()

interface FooterLink {
  label: string
  href: string
}

const links = computed<FooterLink[]>(() => [
  { label: t('layout.footer.copyright.termsAndConditions'), href: `/${locale.value}/terms` },
  { label: t('layout.footer.copyright.privacyAndPolicy'), href: `/${locale.value}/privacy-policy` },
  { label: t('layout.footer.copyright.purchaseGuide'), href: `/${locale.value}/privacy-policy` }
])

const currentYear = computed(() => new Date().getFullYear())
</script>

<style scoped>
.footer-copyright {
  background: #fff;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
  padding: 25px 0;
}

.copyright-content {
  max-width: var(--max-width-container);
  margin: 0 auto;
  padding: 0 40px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 20px;
}

.copyright-text {
  font-family: var(--font-inter);
  font-size: 16px;
  color: #7C777F;
  margin: 0;
}

.copyright-link {
  color: var(--color-dark-blue);
  text-decoration: none;
  transition: color 0.3s ease;
  font-family: var(--font-inter);
  font-size: 16px;
}

.copyright-link:hover {
  color: #00CE9B;
}

.copyright-separator {
  color: var(--color-grey);
}

@media (max-width: 1400px) {
  .copyright-content {
    padding: 0 60px;
  }
}

@media (max-width: 991px) {
  .copyright-content {
    flex-direction: column;
    text-align: center;
    padding: 0 30px;
  }
}

@media (max-width: 767px) {
  .footer-copyright {
    padding: 18px 0;
  }

  .copyright-content {
    padding: 0 20px;
  }

  .copyright-link {
    font-size: 12px;
  }
}
</style>
